// extracted by mini-css-extract-plugin
var _1 = "EntityExtraTags-moduleEntityExtraTags__Rwcfz";
var _2 = "EntityExtraTags-modulenoInteractable__d3DPq";
var _3 = "EntityExtraTags-moduletag__xYd7N Tag-moduleTag__FLr9H";
var _4 = "EntityExtraTags-moduletooltipContent__qRJBl";
export { _1 as "EntityExtraTags", _2 as "noInteractable", _3 as "tag", _4 as "tooltipContent" }
